// invoiceUtils.js
export const getStatusColor = (status) => {
  switch (status) {
    case 'בתהליך עיבוד':
    case 'PROCESSING':
      return 'processing';
    case 'מאושר':
    case 'אושר ונקלט':
      return 'success';
    case 'נדחה':
      return 'error';
    case 'ממתין לאישור':
      return 'warning';
    case 'ממתין לקבלת סחורה':
      return 'info';
    case 'סופית':
    case 'נסגרה בפריוריטי':
      return 'final'; 
    case 'חשבונית ריטיינר - ממתין לשיוך הזמנות':
    case 'PENDING_RETAINER_ALLOCATION':
      return 'retainer'; 
    case 'ממתין לבירור':
    case 'PENDING_CLARIFICATION':
      return 'clarification';
    default:
      return 'default';
  }
};

export const statusColorMap = {
  success: '#388e3c',
  error: '#d32f2f',
  warning: '#f57c00',
  info: '#1976d2',
  processing: '#2196F3',
  final: '#D4AF37', 
  retainer: '#9C27B0', 
  clarification: '#7B1FA2',
  default: '#6B7280',
};
